import AvantiFront from "./front";

AvantiFront.initialization();